import { Component, OnInit, OnDestroy } from '@angular/core';
import { Fordjupning, InGeApiState, InventeringsNiva } from 'src/app/store/state-model/inge-api.model';
import { select, Store } from '@ngrx/store';
import { BehaviorSubject, Observable } from 'rxjs';
import { SublayerConfiguration } from '../../base-components/fordjupning-karta-base/fordjupning-karta.model';
import { environment } from 'src/environments/environment';
import { flatten } from 'lodash-es';
import { FordjupningKartaPopupContent } from '../../base-components/fordjupning-karta-popup/fordjupning-karta-popup.model';
import { formatPercent } from '@angular/common';

@Component({
    selector: 'app-uppfolj-arsskador-tall-karta',
    templateUrl: './uppfolj-arsskador-tall-karta.component.html',
    styleUrls: ['./uppfolj-arsskador-tall-karta.component.scss']
})
export class UppfoljArsskadorTallKartaComponent implements OnInit, OnDestroy {
    private _layerConfig = new BehaviorSubject<SublayerConfiguration>(null);
    layerConfig$ = this._layerConfig.asObservable();
    inventeringsNiva$: Observable<InventeringsNiva>;
    inventeringsNiva: InventeringsNiva;
    fordjupningsData$: Observable<Fordjupning>;
    fordjupningsData: Fordjupning;
    private popupData = new BehaviorSubject<FordjupningKartaPopupContent>(null);
    popupData$ = this.popupData.asObservable();
    isLoadingPopupData: boolean;

    constructor(private store: Store<InGeApiState>) {
        this.inventeringsNiva$ = this.store.pipe(select((x) => x.uppfoljningsrapport.inventeringsNiva));
        this.store.pipe(select((x) => x.uppfoljningsrapport.fordjupning)).subscribe((x) => (this.fordjupningsData = x));
    }
    ngOnDestroy(): void {}
    ngOnInit(): void {
        this.inventeringsNiva$.subscribe((x) => {
            if (x) {
                this.inventeringsNiva = x;
                const mapserviceConfig = environment.kartor.geodataportalVisaAbinrapport_3_0;
                if (x === InventeringsNiva.LAND) {
                    this._layerConfig.next({
                        layerId: mapserviceConfig.sublayers.arsskadorTallLandsdel.id,
                        parentId: mapserviceConfig.sublayers.arsskadorTallLandsdel.parentId
                    });
                }
                if (x === InventeringsNiva.LANDSDEL) {
                    this._layerConfig.next({
                        layerId: mapserviceConfig.sublayers.arsskadorTallLan.id,
                        parentId: mapserviceConfig.sublayers.arsskadorTallLan.parentId
                    });
                }
                if (x === InventeringsNiva.LAN) {
                    this._layerConfig.next({
                        layerId: mapserviceConfig.sublayers.arsskadorTallAfo.id,
                        parentId: mapserviceConfig.sublayers.arsskadorTallAfo.parentId
                    });
                }
            }
        });
    }

    onMapClicked(graphic: __esri.Graphic) {
        this.isLoadingPopupData = true;

        if (!graphic || !this.fordjupningsData || !this.fordjupningsData.inventeringar) {
            return;
        }
        const inventeringar = flatten(this.fordjupningsData.inventeringar);
        let omradeNamn: string;
        let omradeVardePercent: string;
        const contentText = 'Sammanvägning för de tre senaste inventeringarna';
        let thumbsUp = false;
        if (this.fordjupningsData.fordjupningsNiva === InventeringsNiva.LANDSDEL) {
            const landsdelKod = graphic.attributes.LandsdelKod.toString();
            const inventering = inventeringar.filter((x) => x.landsdelKod.toString() === landsdelKod)[0];
            omradeNamn = inventering.landsdelNamn;
            omradeVardePercent = formatPercent(inventering.arsskadaTallAndel3InvMedel, 'sv', '1.0');
            thumbsUp = inventering.slutsatsArsskadaTallInt > 0;
        }
        if (this.fordjupningsData.fordjupningsNiva === InventeringsNiva.LAN) {
            const lanKod = graphic.attributes.LanKod.toString();
            const inventering = inventeringar.filter((x) => x.lanKod === lanKod)[0];
            omradeNamn = `${inventering.landsdelNamn} - ${inventering.lanNamn}`;
            omradeVardePercent = formatPercent(inventering.arsskadaTallAndel3InvMedel, 'sv', '1.0');
            thumbsUp = inventering.slutsatsArsskadaTallInt > 0;
        }
        if (this.fordjupningsData.fordjupningsNiva === InventeringsNiva.AFO) {
            const AFONr = graphic.attributes.AFONr.toString();
            const inventering = inventeringar.filter((x) => x.afoNr.toString() === AFONr)[0];
            omradeNamn = `${inventering.lanNamn} - ${inventering.afoNamn} (ÄFO nr ${inventering.afoNr})`;
            omradeVardePercent = formatPercent(inventering.arsskadaTallAndel3InvMedel, 'sv', '1.0');
            thumbsUp = inventering.slutsatsArsskadaTallInt > 0;
        }

        this.popupData.next({
            omradeNamn,
            omradeVarde: `Årsskadad tall, ${omradeVardePercent}`,
            contentText,
            thumbsUp
        });
        this.isLoadingPopupData = false;
    }
}
